module.exports = __webpack_public_path__ + "img/close-icon.98002d3c.svg";